
export class MupdfError extends Error {
  constructor(message) {
    super(message);
    this.name = "MupdfError";
  }
}
